import { Box, styled } from '@mui/material';

export const OverlayStyle = styled(Box)({
	cursor: 'pointer',
	position: 'fixed',
	inset: 0,
	background: 'rgba(0, 0, 0, 0.4)',
	zIndex: 1500,
});

export const ModalStyle = styled(Box)({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: '#fff',
	borderRadius: '8px',
	width: 'min(900px, calc(100% - 48px))',
	maxHeight: '90vh',
	overflow: 'auto',
	boxShadow: '0 12px 32px rgba(0, 0, 0, 0.25)',
	zIndex: 1501,
});

export const HeaderStyle = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '16px 20px',
	borderBottom: '1px solid #e6e6e6',
});

export const ContentStyle = styled(Box)({
	padding: '16px 20px',
});

export const ActionsStyle = styled(Box)({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: '8px',
	padding: '16px 20px',
	borderTop: '1px solid #e6e6e6',
});
